import { render, staticRenderFns } from "./UdfRuntimeModal.vue?vue&type=template&id=2a0613c2&"
import script from "./UdfRuntimeModal.vue?vue&type=script&lang=js&"
export * from "./UdfRuntimeModal.vue?vue&type=script&lang=js&"
import style0 from "./UdfRuntimeModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports